module.exports = __webpack_public_path__ + "f18b027f339a9583fe75d5f28008f01a.svg";